export enum InvoiceStatus {
  PENDING = 1,
  LOADED = 2,
  APPROVED = 3,
  INVOICED = 4,
  CANCELED = 5,
}
